import { IInitialState } from 'store/models';
import { moduleStateSelector } from '../moduleStateSelector';

export function authStateSelector(state: IInitialState) {
	return moduleStateSelector(state).auth;
}
